import axios from "@/libs/api.request";
// 获取列表
export const getList = params => {
  return axios.request({
    url: "/finance/ChannelCost",
    method: "get",
    params
  });
};
// 创建列表
export const add = data => {
  return axios.request({
    url: "/finance/ChannelCost",
    data,
    method: "post"
  });
};
// 获取详情
export const getDetails = id => {
  return axios.request({
    url: `/finance/ChannelCost/${id}`,
    method: "GET"
  });
};
// 更新列表
export const update = data => {
  return axios.request({
    url: `/finance/ChannelCost/${data.id}`,
    method: "put",
    data
  });
};

// 删除列表
export const del = id => {
  return axios.request({
    url: `/finance/ChannelCost/${id}`,
    method: "DELETE"
  });
};

// 获取配置
export const getConfig = params => {
  return axios.request({
    url: "/finance/ChannelCost/conf",
    method: "get",
    params
  });
};

export const log = params => {
  return axios.request({
    url: "/authority/menu/log",
    method: "get",
    params
  });
};
